/* ──────────────────────────────────────────────────────────────────────────
   Les packs de tickets — le comportement.

   Ce code vivait dans le snippet, en balise <script>. Il ne s'exécutait alors
   que sur les pages où un bloc était rendu côté SERVEUR : le tiroir de fiche et
   le tiroir de panier sont injectés en innerHTML, et un <script> inséré de cette
   façon n'est jamais exécuté par le navigateur. Les boutons ne faisaient donc
   rien dans les deux endroits qui comptent. D'où ce fichier, chargé une fois
   pour toutes dans la mise en page.

   Tout est en écoute déléguée sur le document, pour la même raison : les deux
   tiroirs sont redessinés à chaque mise à jour, et des écouteurs posés sur les
   boutons disparaîtraient avec eux.
   ────────────────────────────────────────────────────────────────────────── */

    (function () {
if (window.__packsTickets) return;
window.__packsTickets = true;


function selecteurPour(bouton) {
  var n = bouton.parentElement;
  while (n && n !== document.body) {
    var s = n.querySelector('quantity-selector');
    if (s && typeof s.change_quantity === 'function') return s;
    n = n.parentElement;
  }
  return null;
}

function s(n) { return n > 1 ? 's' : ''; }

// Dans la fiche, rien ne se redessine côté serveur : c'est ici qu'on tient le
// texte à jour, aussi bien après un clic sur un pack qu'après les boutons + et −
// du thème. Dans le tiroir de panier, Liquid a déjà tout recalculé — la fonction
// retrouve simplement les mêmes valeurs.
function rafraichir(bloc, qte) {
  if (!bloc) return;
  var tranche = parseInt(bloc.getAttribute('data-tranche'), 10) || 5;
  var offerts = Math.floor(qte / tranche);
  var chances = qte + offerts;
  var manque = tranche - (qte % tranche);

  // Les deux moitiés — la phrase et les cartes — sont séparées dans le balisage pour
  // que la phrase puisse se poser à côté de la quantité. Elles se mettent à jour
  // ensemble : on remonte au formulaire qui les contient et on traite les deux.
  var portee = bloc.closest('product-form') || bloc.closest('form') || bloc.closest('.side-panel') || document;
  portee.querySelectorAll('[data-packs-tickets]').forEach(function (part) {
    var mot = part.matches('.packs-mot') ? part : part.querySelector('.packs-mot');
    if (mot) {
      // Mêmes trois états que dans le Liquid, dans le même ordre : un palier à
      // portée passe devant le compliment.
      if (manque <= 2) {
        var rang = offerts + 1;
        mot.innerHTML = 'Plus que ' + manque + ' ticket' + s(manque) +
          ' <span class="packs-mot__suite">pour un ' + (rang > 1 ? rang + '<sup>e</sup> ' : '') + 'offert</span>';
      } else if (offerts > 0) {
        mot.innerHTML = '<strong>' + offerts + ' offert' + s(offerts) +
          '</strong> <span class="packs-mot__suite">\u00b7 ' + chances + ' chances</span>';
      } else {
        mot.innerHTML = 'Encore ' + manque + ' ticket' + s(manque) +
          ' <span class="packs-mot__suite">pour 1 offert</span>';
      }
    }
    part.querySelectorAll('.panier-pack').forEach(function (p) {
      p.classList.toggle('panier-pack--actif', parseInt(p.getAttribute('data-panier-pack'), 10) === qte);
    });
  });
  libelleAchat(bloc, qte);
}

// Le bouton d'achat s'accorde avec la quantité : « un ticket » au singulier, « des
// tickets » au-delà. On garde l'impératif du thème — « Achetez » — pour ne pas se
// retrouver avec deux formes verbales sur la même page.
//
// On ne touche qu'au bouton du FORMULAIRE qui porte ce bloc : dans le tiroir de panier
// il n'y en a pas, la recherche ne trouve rien, et la fonction ne fait rien.
function libelleAchat(bloc, qte) {
  var form = bloc.closest('product-form') || bloc.closest('form');
  if (!form) return;
  var bouton = form.querySelector('.single_add_to_cart_button');
  if (!bouton || bouton.classList.contains('sold-out')) return;
  var cible = bouton.querySelector('span') || bouton;
  var texte = qte > 1 ? 'Achetez des tickets' : 'Achetez un ticket';
  if (cible.textContent.trim() !== texte) cible.textContent = texte;
}

// À l'ouverture d'une fiche, la quantité peut ne pas valoir 1 — le visiteur revient sur
// un lot, le thème redessine le tiroir. On accorde donc le libellé dès que le bloc
// apparaît, sans attendre un clic.
function accorderTout() {
  document.querySelectorAll('[data-packs-tickets]').forEach(function (bloc) {
    var n = bloc.parentElement, sel = null;
    while (n && n !== document.body && !sel) {
      sel = n.querySelector('quantity-selector');
      n = n.parentElement;
    }
    var champ = sel && sel.querySelector('.qty');
    var qte = parseInt(champ && champ.value, 10);
    if (!isNaN(qte)) rafraichir(bloc, qte);
  });
}
addEventListener('load', accorderTout);
// Les tiroirs arrivent après coup : on repasse quand le contenu de la page change.
// Le rafraîchissement est rangé dans un délai pour ne pas tourner à chaque mutation.
var enAttente = null;
new MutationObserver(function () {
  clearTimeout(enAttente);
  enAttente = setTimeout(accorderTout, 120);
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', function (e) {
  var bouton = e.target.closest('[data-panier-pack]');
  if (!bouton) return;
  var selecteur = selecteurPour(bouton);
  if (!selecteur) return;
  var champ = selecteur.querySelector('.qty');
  var actuelle = parseInt(champ && champ.value, 10);
  if (isNaN(actuelle)) actuelle = 1;
  var vise = parseInt(bouton.getAttribute('data-panier-pack'), 10);
  if (vise !== actuelle) selecteur.change_quantity(vise - actuelle);
  rafraichir(bouton.closest('[data-packs-tickets]'), vise);
});

// Les boutons + et − du thème émettent « change » sur le champ : on s'y accroche
// pour que le texte suive aussi quand le visiteur ne passe pas par un pack.
document.addEventListener('change', function (e) {
  var champ = e.target.closest('.qty');
  if (!champ) return;
  var selecteur = champ.closest('quantity-selector');
  if (!selecteur) return;
  var n = selecteur.parentElement, bloc = null;
  while (n && n !== document.body && !bloc) {
    bloc = n.querySelector('[data-packs-tickets]');
    n = n.parentElement;
  }
  var qte = parseInt(champ.value, 10);
  if (bloc && !isNaN(qte)) rafraichir(bloc, qte);
});
    })();
  
